import "./Representante.css";
import { MapBrazil } from 'react-brazil-map'
import { useState } from "react";
import Popup from "reactjs-popup";
import Footer from "../../components/Footer/Footer";
import Navbar from "../../components/Menu/Menu";

function Representante() {


  const [distritc, setDistrict] = useState('')

  return (
    <>
      <Navbar />
      <div className='representantePage'>
        <div className="textPageRepre">
          <h1>Encontre um <br />
            <strong>representante</strong></h1>
          <p>Para facilitar seu atendimento, a Cia Canoinhas dispõe de uma rede de representantes<br />
            por todo Brasil. Para localizar o mais próximo de você entre em contato pelos telefones<br />
            ou e-mails abaixo.</p>

          <Popup trigger={<button className="button"> Procurar Representante</button>} modal>
            <div className="formularioCard">
              <h1>Preencha o <br /><strong>Formulário</strong></h1>
              <p>O time de vendas responsável entrará em contato com você o mais breve possível!</p>
              <input type="name" placeholder="Digite seu nome completo" />
              <input type="email" placeholder="Digite seu email" />
              <input type="phone" placeholder="Digite seu telefone com o DDD" />
              <textarea type="text" placeholder="Mensagem" />
              <button type="submit">Enviar</button>
            </div>
          </Popup>
        </div>
        <Popup trigger={<div className="mapaBrasil">
          <MapBrazil width={500} height={500} fill='#009BDB' colorLabel='#FFF' onChange={setDistrict} />
          <p>Estado selecionado: <strong>{distritc}</strong></p>
        </div>
        } modal>
          <div className="formularioCard">
            <h1>Preencha o <br /><strong>Formulário</strong></h1>
            <p>O time de vendas responsável entrará em contato com você o mais breve possível!</p>
            <input type="name" placeholder="Digite seu nome completo" />
            <input type="email" placeholder="Digite seu email" />
            <input type="phone" placeholder="Digite seu telefone com o DDD" />
            <textarea type="text" placeholder="Mensagem" />
            <button type="submit">Enviar</button>
          </div>
        </Popup>

      </div>
      <Footer />
    </>

  )
}

export default Representante;